import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/** Router state the demo tour sets when it navigates back to the projects page. */
export const WALKTHROUGH_COMPLETED_STATE_KEY = 'walkthroughCompleted';

/**
 * Opens the "You're all set" modal on the page a finished demo tour lands on
 * (the projects page). The tour navigates there with
 * `{ state: { walkthroughCompleted: true } }`; this hook consumes that flag
 * once and clears it from the history entry, so back/forward/reload never
 * re-open the modal. Returns `{ isOpen, close }` for `WalkthroughCompleteModal`.
 */
export function useWalkthroughCompletedLanding() {
    const location = useLocation();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const completed = Boolean(location.state?.[WALKTHROUGH_COMPLETED_STATE_KEY]);

    useEffect(() => {
        if (!completed) return;
        setIsOpen(true);
        navigate({ pathname: location.pathname, search: location.search }, { replace: true, state: null });
    }, [completed, location.pathname, location.search, navigate]);

    const close = useCallback(() => setIsOpen(false), []);

    return { isOpen, close };
}

export default useWalkthroughCompletedLanding;
